<mat-drawer-container autosize hasBackdrop="true">
  <mat-drawer #drawer mode="over" position="end">
    <nmfta-downloads-panel (closePanel)="drawer.close()"></nmfta-downloads-panel>
  </mat-drawer>

  <div class="root-container">
    <div class="root-header">
      <nmfta-nav-bar (downloadsClicked)="toggleDrawer()"></nmfta-nav-bar>
    </div>
    <div class="root-content container">
      <router-outlet />
    </div>
    <div class="root-footer">
      <nmfta-footer></nmfta-footer>
    </div>
  </div>
</mat-drawer-container>
